import React from 'react';
import { motion } from 'framer-motion';

const KPICard = ({ title, value, icon, trend, trendValue, color }) => {
  return (
    <motion.div 
      whileHover={{ y: -5 }}
      className="glass-card p-4 h-100"
    >
      <div className="d-flex justify-content-between align-items-start mb-3">
        <div className={`p-3 rounded-3 bg-opacity-10 bg-${color} text-${color}`}>
          {icon}
        </div>
        <div className={`text-${trend === 'up' ? 'success' : 'danger'} small fw-bold`}>
          {trend === 'up' ? '+' : '-'}{trendValue}%
        </div>
      </div>
      <div>
        <p className="text-muted small uppercase fw-bold mb-1">{title}</p>
        <h3 className="fw-bold mb-0">{value}</h3>
      </div>
    </motion.div>
  );
};

export default KPICard;
